import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { ContabilidadModule } from 'src/contabilidad/contabilidad.module';
import { AuditModule } from 'src/audit/audit.module';
import { RecibosController } from './recibos.controller';
import { RetencionesController } from './retenciones.controller';
import { RecibosService } from './recibos.service';

@Module({
  imports: [PrismaModule, ContabilidadModule, AuditModule],
  controllers: [RecibosController, RetencionesController],
  providers: [RecibosService],
  exports: [RecibosService],
})
export class RecibosModule {}
